import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MeinProjekt } from '../../../models/mein-projekt.model';
import { getProjectIconDef } from '../../../utils/project-icon.utils';

export const PROJEKTE_VERWALTEN_ID = 'projekte-verwalten-popover';

const namensfolge = new Intl.Collator('de', { sensitivity: 'base' });

@Component({
  selector: 'app-projekte-verwalten',
  imports: [TranslatePipe],
  templateUrl: './projekte-verwalten.component.html',
  styleUrl: './projekte-verwalten.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjekteVerwaltenComponent {
  readonly projekte = input.required<MeinProjekt[]>();
  readonly angeheftet = input.required<ReadonlySet<string>>();
  readonly ausgeblendet = input.required<ReadonlySet<string>>();
  readonly stern = output<string>();
  readonly haekchen = output<string>();
  readonly schliessen = output<void>();

  protected readonly id = PROJEKTE_VERWALTEN_ID;
  protected readonly sortiert = computed(() =>
    [...this.projekte()].sort((a, b) => namensfolge.compare(a.name, b.name)),
  );

  protected farbe(projekt: MeinProjekt): string {
    return getProjectIconDef(projekt).color;
  }

  protected schrift(projekt: MeinProjekt): string {
    return getProjectIconDef(projekt).onColor;
  }

  protected haekchenGeaendert(event: Event, projectId: string): void {
    // Der Haken folgt allein dem Layout: Ohne diesen Rücksprung bliebe er bei einem Speicherfehler falsch stehen.
    const feld = event.target as HTMLInputElement;
    feld.checked = !feld.checked;
    this.haekchen.emit(projectId);
  }
}
